import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from 'react-router-dom';

import NavMenu from './components/NavMenu';

import HomePage from './pages/HomePage';
import AnimalPage from './pages/AnimalPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import FavoritesPage from './pages/FavoritesPage';
import ExplorePage from './pages/ExplorePage';
import ListsPage from './pages/ListsPage';
import ListDetailPage from './pages/ListDetailPage';
import TemporaryIntersectionPage from './pages/TemporaryIntersectionPage';

import './App.css';

function AccountRequired({ feature }) {
  return (
    <div className="account-required">
      <div className="account-required__card">
        <div className="account-required__icon" aria-hidden="true">
          🔒
        </div>
        <h1>Login Required</h1>
        <p>You need an account to access {feature}.</p>
        <p>
          Log in to your existing account or sign up to start
          saving and organizing animals.
        </p>
        <div className="account-required__actions">
          <Link to="/login" className="account-required__login">
            Login
          </Link>
          <Link to="/register" className="account-required__signup">
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
}

function ProtectedPage({ isAuthenticated, feature, children }) {
  if (!isAuthenticated) {
    return <AccountRequired feature={feature} />;
  }
  return children;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => Boolean(localStorage.getItem('token'))
  );

  return (
    <Router>
      <div className="app-container">
        <NavMenu
          isAuthenticated={isAuthenticated}
          setIsAuthenticated={setIsAuthenticated}
        />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/animal/:id" element={<AnimalPage />} />
            <Route
              path="/intersection-preview"
              element={<TemporaryIntersectionPage />}
            />
            <Route
              path="/login"
              element={<LoginPage setIsAuthenticated={setIsAuthenticated} />}
            />
            <Route path="/register" element={<RegisterPage />} />

            <Route
              path="/favorites"
              element={
                <ProtectedPage
                  isAuthenticated={isAuthenticated}
                  feature="Favorites"
                >
                  <FavoritesPage />
                </ProtectedPage>
              }
            />
            <Route
              path="/lists"
              element={
                <ProtectedPage
                  isAuthenticated={isAuthenticated}
                  feature="your animal lists"
                >
                  <ListsPage />
                </ProtectedPage>
              }
            />
            <Route
              path="/lists/:id"
              element={
                <ProtectedPage
                  isAuthenticated={isAuthenticated}
                  feature="your animal lists"
                >
                  <ListDetailPage />
                </ProtectedPage>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedPage
                  isAuthenticated={isAuthenticated}
                  feature="your profile"
                >
                  <ProfilePage isAuthenticated={isAuthenticated} />
                </ProtectedPage>
              }
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
